import React, { useEffect, useState } from "react"
import {
  Row,
  Col,
  Card,
  CardBody,
  Input,
  Label,
  Button,
  Form,
  Alert,
  FormGroup,
  Modal,
} from "reactstrap"
import { post, del } from "../../helpers/api_helper"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import PartnerBranch from "../PartnersBranch/AddPartnerBranch"
import { Trans } from "react-i18next"
import { useNavigate } from "react-router-dom"
import {
  ADD_PARTNER,
  UPLOAD_FILE,
  COUNTRIES_SEARCH,
  ADD_PARTNER_BRANCH,
  REMOVE_PARTNER,
  LANGUAGES_SEARCH,
  ADD_USER,
  REMOVE_USER,
  ASSIGN_ROLE,
} from "helpers/api_endpoints"
import moment from "moment"
import Select from "react-select"

//meta title
document.title = "Add Partner"

const AddPartner = () => {
  const [status, setStatus] = useState(1)
  const [name, setName] = useState('{"title":[{"1":""}]}')
  const [named, setNamed] = useState("")
  const [languages, setLanguages] = useState([])
  const [phoneNumber, setPhoneNumber] = useState("")
  const [email, setEmail] = useState(null)
  const [password, setPassword] = useState(null)
  const [userId, setUserId] = useState("")
  const [pickupConfirmationMethods, setPickupConfirmationMethods] = useState([])
  const [deliveryConfirmationMethods, setDeliveryConfirmationMethods] =
    useState([])
  const [branchData, setBranchData] = useState(null)
  const [isModalOpen, setIsModalOpen] = useState("")
  const [verifyType, setVerifyType] = useState(2)
  const [emergencyNotification, setEmergencyNotification] = useState(1)
  const [licenseFilePath, setLicenseFilePath] = useState("")
  const [countryCode, setCountryCode] = useState("")
  const [contractStartDate, setContractStartDate] = useState(
    moment().format("YYYY-MM-DD")
  )
  const [contractEndDate, setContractEndDate] = useState(
    moment().add(1, "y").format("YYYY-MM-DD")
  )
  const [countries, setCountries] = useState(() => [
    { value: "0", label: "None" },
  ])
  const [errorMsg, seterrorMsg] = useState([])
  const [loading, setLoading] = useState(false)
  const navigate = useNavigate()

  const itemConfirmationList = [
    { label: "Scan QR Code", value: "1" },
    { label: "Take a photo of the package", value: "2" },
  ]
  const deliveryConfirmationList = [
    { value: "Passport", label: "Passport" },
    { value: "Emirates ID", label: "Emirates ID" },
    { value: "Door image", label: "Door image" },
    { value: "User OTP", label: "User OTP" },
  ]

  useEffect(() => {
    console.log(moment().format("DD-MM-YYYY"))
  }, [])

  useEffect(() => {
    post(`${LANGUAGES_SEARCH}`, { status: 1 })
      .then(response => {
        setLanguages(response.data)
        // console.log(languages);
        setLoading(false)
      })
      .catch(error => {
        console.log(error)
        // navigate('/collhub');
      })
  }, [])

  useEffect(() => {
    console.log(moment().format("DD-MM-YYYY"))
    const start = moment(contractStartDate, "YYYY-MM-DD")
    const end = moment(contractEndDate, "YYYY-MM-DD")
    if (start.diff(end) >= 0) {
      setContractEndDate(start.add(1, "y").format("YYYY-MM-DD"))
    }
  }, [contractEndDate, contractStartDate])

  useEffect(() => {
    getCountries()
  }, [])

  const validatePartnerData = () => {
    const errors = []

    if (!name || name === '{"title":[{"1":""}]}') {
      errors.push("Partner name is required")
    }

    if (!email) {
      errors.push("Email is required")
    }

    if (!password) {
      errors.push("Password is required")
    }
    if (!phoneNumber) {
      errors.push("Phone number is required")
    }

    if (!countryCode) {
      errors.push("Country code is required")
    }
    if (!licenseFilePath) {
      errors.push("Commercial License is required")
    }

    if (!contractStartDate) {
      errors.push("Contract start date is required")
    }

    if (!contractEndDate) {
      errors.push("Contract end date is required")
    }

    if (!pickupConfirmationMethods || pickupConfirmationMethods.length === 0) {
      errors.push("Pickup item confirmation method is required")
    }
    if (
      !deliveryConfirmationMethods ||
      deliveryConfirmationMethods.length === 0
    ) {
      errors.push("Delivery confirmation method is required")
    }

    return errors
  }

  const handleSubmit = () => {
    // Clear previous errors
    seterrorMsg([])

    // Validate all required fields
    const validationErrors = validatePartnerData()

    if (validationErrors.length > 0) {
      seterrorMsg(validationErrors)
      // Scroll to top to show errors
      window.scrollTo({ top: 0, behavior: "smooth" })
      return false
    }

    // If validation passes, open modal for branch data
    setIsModalOpen(true)
    return true
  }

  const getCountries = () => {
    post(`${COUNTRIES_SEARCH}`).then(response => {
      setCountries(
        [{ value: "0", label: "None" }].concat(
          response.data.map(el => {
            return {
              value: el.countryCode,
              label: el.countryCode,
              flagUrl: el.countryCode,
            }
          })
        )
      )
    })
  }

  const handleToggleCheckBox = inputFunction => {
    switch (inputFunction) {
      case "setStatus":
        if (status == 1) {
          setStatus(2)
        } else {
          setStatus(1)
        }
        console.log(status)
        break
      case "setVerifyType":
        if (verifyType == 1) {
          setVerifyType(2)
        } else {
          setVerifyType(1)
        }
        break
      case "setEmergencyNotification":
        if (emergencyNotification == 1) {
          setEmergencyNotification(0)
        } else {
          setEmergencyNotification(1)
        }
        break
      default:
        break
    }
  }

  const checkPhoneNumber = (type, value) => {
    const regx1 = /^(50|52|54|55|56|58)\d{7}$/
    const regx2 = /^(02|03|04|05|06|07|08)\d{7}$/

    if (type === 1 && value.length < 9) {
      // onBlur
      if (!regx1.test(value) && !regx2.test(value)) {
        setPhoneNumber("")
        return
      }
    }

    // Only update if the value actually changed
    if (phoneNumber !== value) {
      setPhoneNumber(value)
    }
  }

  // Helper function to cleanup records (note: backend uses soft delete)
  const cleanupRecord = async (endpoint, id, type = "") => {
    try {
      await del(endpoint, { id })
      console.log(`Marked ${type} as deleted (ID: ${id})`)
    } catch (error) {
      console.error(`Error deleting ${type} with ID ${id}:`, error.message)
    }
  }

  const assignPartnerRole = async userId => {
    try {
      // Try to assign the partner role (ID 4)
      const roleResponse = await post(ASSIGN_ROLE, {
        UserId: userId,
        RoleId: 4,
      })

      if (roleResponse.code !== 200 && roleResponse.code !== 201) {
        console.warn(
          "Failed to assign partner role, but continuing with partner creation"
        )
      }
    } catch (error) {
      console.warn("Error assigning partner role:", error.message)
    }
  }

  const saveUserData = async (branchData = null) => {
    let userData = null
    let partnerData = null

    try {
      setLoading(true)
      seterrorMsg([])

      // 1. First create the user
      const userResponse = await post(ADD_USER, {
        name: "partner",
        email,
        password,
        mobile: phoneNumber,
        status: 2,
      })

      if (userResponse.code !== 201 || !userResponse.data?.id) {
        throw new Error("Failed to create user account")
      }

      userData = userResponse.data
      let partnerResponse

      try {
        // 2. Try to assign partner role
        await assignPartnerRole(userData.id)

        // 3. Create partner
        const cleanedCountryCode = countryCode
          ? countryCode.replace("+", "")
          : ""
        const fullPhoneNumber =
          cleanedCountryCode && phoneNumber
            ? `${cleanedCountryCode}${phoneNumber}`
            : phoneNumber

        partnerResponse = await post(ADD_PARTNER, {
          name,
          licenseFilePath,
          phoneNumber: fullPhoneNumber,
          contractStartDate,
          contractEndDate,
          verifyType,
          status,
          countryCode: cleanedCountryCode,
          pickupConfirmationMethods,
          deliveryConfirmationMethods,
          userId: userData.id,
          emergencyNotification: emergencyNotification,
        })

        if (partnerResponse.code !== 201) {
          throw new Error(partnerResponse.message || "Failed to create partner")
        }

        partnerData = partnerResponse.data

        // 4. Create branch if branch data exists
        if (branchData && partnerData?.id) {
          const branchResponse = await post(ADD_PARTNER_BRANCH, {
            ...branchData,
            partnerId: partnerData.id,
          })

          if (branchResponse.code === 201) {
            navigate("/Partners", {
              state: { successMsg: "Partner and branch added successfully" },
            })
            return
          } else {
            throw new Error(
              branchResponse.message || "Failed to create partner branch"
            )
          }
        }

        // If no branch data, just redirect to partners list
        navigate("/Partners", {
          state: { successMsg: "Partner added successfully" },
        })
      } catch (error) {
        // Cleanup partially created records
        // Note: Backend uses soft delete, so these records will be marked as deleted

        if (partnerData?.id) {
          await cleanupRecord(REMOVE_PARTNER, partnerData.id, "partner")
        }

        if (userData?.id) {
          await cleanupRecord(REMOVE_USER, userData.id, "user")
        }

        const errorMessage =
          error?.response?.data?.message || error.message || "An error occurred"
        const errorArray = Array.isArray(errorMessage)
          ? errorMessage
          : [errorMessage]

        const hasUniqueError = errorArray.some(
          msg =>
            msg &&
            (msg.includes("already in use") ||
              msg.includes("already exists") ||
              msg.includes("unique"))
        )

        if (hasUniqueError) {
          errorArray.push(
            "Note: If you previously attempted to create this partner and it failed, you may need to use different email/phone or contact support to restore the previous record."
          )
        }

        seterrorMsg(prev => [
          ...new Set([...prev, ...errorArray.filter(Boolean)]),
        ])
      }
    } catch (error) {
      const errorMessage =
        error?.response?.data?.message ||
        error.message ||
        "Failed to create partner"
      seterrorMsg(prev =>
        [
          ...prev,
          ...(Array.isArray(errorMessage) ? errorMessage : [errorMessage]),
        ].filter(Boolean)
      )
    } finally {
      setLoading(false)
    }
  }

  const handleCountryCode = countryCode => {
    setCountryCode(countryCode)
  }

  const setPartner = branchData => {
    setIsModalOpen(false)
    setBranchData(branchData)
    saveUserData(branchData)
  }

  const handleFileUpload = event => {
    setLoading(true)
    const file = event.target.files[0]
    post(
      `${UPLOAD_FILE}`,
      { file, type: "partners", fullPath: "true" },
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    )
      .then(response => {
        const data = response.data
        setLicenseFilePath(data.path)
        setLoading(false)
      })
      .catch(error => {})
  }

  const handleName = (languageId, value) => {
    if (!named.title) {
      setNamed({ title: [{ 1: value }] })
      return
    }
    const ln = named.title.filter(el => {
      return Object.keys(el)[0] == languageId
    })

    if (ln == undefined || ln.length < 1) {
      const ob = {}
      ob[languageId] = value
      named.title.push(ob)
    } else {
      ln[0][languageId] = value
    }
    setName(JSON.stringify(named))
  }

  return (
    <React.Fragment>
      <Modal
        isOpen={isModalOpen}
        toggle={() => setIsModalOpen(!isModalOpen)}
        size="lg"
      >
        <PartnerBranch setPartner={setPartner} branchData={branchData} />
      </Modal>
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs title="Partners" breadcrumbItem="Add Partner" />
          <Form
            className="form-horizontal"
            onSubmit={e => {
              e.preventDefault()
              setIsModalOpen(true)
              // handleSubmit();
              return false
            }}
          >
            <Row>
              <Col xl={12}>
                <Card>
                  <CardBody>
                    <Row>
                      {errorMsg.length > 0 && (
                        <Alert color="danger">
                          {errorMsg.map((msg, idx) => (
                            <li key={idx}>{msg}</li>
                          ))}
                        </Alert>
                      )}

                      {languages.map((language, index) => (
                        <div className="form-group col-md-3 mt-2" key={index}>
                          <Label className="form-label">
                            <Trans>Name ({language.name})</Trans>
                          </Label>
                          <Input
                            name="name"
                            value={
                              named.title
                                ? named.title.find(el => {
                                    return el[language.id]
                                  })
                                  ? named.title.find(el => {
                                      return el[language.id]
                                    })[language.id]
                                  : ""
                                : ""
                            }
                            className="form-control"
                            placeholder="Enter Name"
                            type="text"
                            onChange={e =>
                              handleName(language.id, e.target.value)
                            }
                            required={
                              language.id == 1 || language.id == 2
                                ? true
                                : false
                            }
                          ></Input>
                          <Input type="hidden" name="id"></Input>
                        </div>
                      ))}

                      <div className="form-group col-md-4 mt-2">
                        <Label className="form-label">
                          <Trans>Email</Trans>
                        </Label>
                        <Input
                          name="email"
                          value={email}
                          className="form-control"
                          placeholder="Enter Email"
                          type="email"
                          autoComplete="off"
                          onChange={e => setEmail(e.target.value)}
                          required
                        ></Input>
                      </div>

                      <div className="form-group col-md-4 mt-2">
                        <Label className="form-label">
                          <Trans>Password</Trans>
                        </Label>
                        <Input
                          name="password"
                          className="form-control"
                          placeholder="Enter Password"
                          type="password"
                          autoComplete="false"
                          onChange={e => setPassword(e.target.value)}
                          required
                        ></Input>
                      </div>

                      <div className="form-group col-md-4 mt-2">
                        <Label className="form-label">
                          <Trans>Country Code</Trans>
                        </Label>
                        <Select
                          name="countryCode"
                          value={
                            countryCode
                              ? countries.find(el => el.value === countryCode)
                              : null
                          }
                          options={countries}
                          className="form-control select2"
                          onChange={e => handleCountryCode(e.value)}
                        />
                      </div>

                      <div className="form-group col-md-4 mt-2">
                        <Label className="form-label">
                          <Trans>Phone Number</Trans>
                        </Label>
                        <Input
                          name="phoneNumber"
                          value={phoneNumber}
                          className="form-control"
                          placeholder="Enter Phone Number"
                          type="text"
                          onBlur={e => checkPhoneNumber(1, e.target.value)}
                          onChange={e => checkPhoneNumber(2, e.target.value)}
                          required
                        ></Input>
                      </div>

                      <div className="form-group col-md-4 mt-2">
                        <Label className="form-label">
                          <Trans>Contract Start Date</Trans>
                        </Label>
                        <Input
                          name="contractStartDate"
                          value={contractStartDate}
                          className="form-control"
                          placeholder="Enter "
                          type="date"
                          onChange={e => setContractStartDate(e.target.value)}
                          required
                        ></Input>
                      </div>

                      <div className="form-group col-md-4 mt-2">
                        <Label className="form-label">
                          <Trans>Contract End Date</Trans>
                        </Label>
                        <Input
                          name="contractEndDate"
                          value={contractEndDate}
                          className="form-control"
                          placeholder="Enter "
                          type="date"
                          onChange={e => setContractEndDate(e.target.value)}
                          required
                        ></Input>
                      </div>

                      <div className="form-group col-md-2 mt-2">
                        <Label className="form-label">
                          <Trans>Status</Trans>
                        </Label>
                        <div className="form-check form-check-end">
                          <FormGroup switch>
                            <Input
                              type="switch"
                              size="md"
                              checked={status == 2}
                              onClick={() => {
                                handleToggleCheckBox("setStatus")
                              }}
                            />
                          </FormGroup>
                        </div>
                      </div>
                      <div className="form-group col-md-2 mt-2">
                        <Label className="form-label">
                          <Trans>Emergency notification</Trans>
                        </Label>
                        <div className="form-check form-check-end">
                          <FormGroup switch>
                            <Input
                              type="switch"
                              size="md"
                              checked={emergencyNotification == 1}
                              onClick={() => {
                                handleToggleCheckBox("setEmergencyNotification")
                              }}
                            />
                          </FormGroup>
                        </div>
                      </div>
                      <div className="form-group col-md-4 mt-2">
                        <Label className="form-label">
                          <Trans>Pickup item confirmation</Trans>
                        </Label>
                        <Select
                          isMulti="true"
                          name="deliveryConfirmationMethods"
                          value={itemConfirmationList.filter(el => {
                            return pickupConfirmationMethods.includes(el.value)
                          })}
                          options={itemConfirmationList}
                          className="form-control select2"
                          onChange={e => {
                            setPickupConfirmationMethods(e.map(m => m.value))
                          }}
                          required
                        />
                      </div>
                      <div className="form-group col-md-4 mt-2">
                        <Label className="form-label">
                          <Trans>Delivery Confirmation Methods</Trans>
                        </Label>
                        <Select
                          isMulti="true"
                          name="itemConfirmations"
                          value={deliveryConfirmationList.filter(el => {
                            return deliveryConfirmationMethods.includes(
                              el.value
                            )
                          })}
                          options={deliveryConfirmationList}
                          className="form-control select2"
                          onChange={e => {
                            setDeliveryConfirmationMethods(e.map(m => m.value))
                          }}
                          required
                        />
                      </div>
                      <div className="form-group col-md-4 mt-2">
                        <Label className="form-label">
                          <Trans>Add Commercial License</Trans>
                        </Label>
                        <input
                          className="form-control"
                          type="file"
                          onChange={handleFileUpload}
                        />
                        <img src={licenseFilePath} className="w-100" />
                      </div>
                    </Row>
                    <div className="mt-4">
                      <Button
                        type="button"
                        color="danger"
                        onClick={handleSubmit}
                        disabled={loading}
                      >
                        <Trans>{loading ? "Processing..." : "Submit"}</Trans>
                      </Button>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Form>
        </div>
      </div>
    </React.Fragment>
  )
}

export default AddPartner
